export default __webpack_public_path__ + "static/media/android-os.ecd107ea.svg";